/**
 * GenerateFileChip — informational chip that renders a
 * <GENERATE_FILE external_local_path="..."></GENERATE_FILE> tag.
 *
 * Context:
 *   The GENERATE_FILE tag is part of CellCog's SDK protocol. When an
 *   OpenClaw (or similar) client invokes an agent with
 *   `external_local_path` declared, that path gets embedded in the chat
 *   message as a GENERATE_FILE tag so the agent can honor it while
 *   producing output. Humans reading the chat history shouldn't see the
 *   raw protocol syntax — they should see a clean, informational chip.
 *
 * This chip is render-only. No click action in v1. Tooltip on the path
 * shows the full value so truncated paths remain readable.
 */
import { DownloadOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
import './GenerateFileChip.css';

const GenerateFileChip = ({ externalLocalPath }) => {
  const path = externalLocalPath || '';
  if (!path) return null;

  return (
    <div className="cellcog-generate-file-chip" role="group" aria-label="Output file destination">
      <span className="cellcog-generate-file-chip__icon" aria-hidden="true">
        <DownloadOutlined />
      </span>
      <div className="cellcog-generate-file-chip__body">
        <div className="cellcog-generate-file-chip__label">
          Output file destination
        </div>
        <Tooltip title={path} placement="top">
          <div className="cellcog-generate-file-chip__path">
            {path}
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default React.memo(GenerateFileChip);
